import { ProductNameEnum } from '../../product-package-names';

export enum ProgramStatus {
  Draft = 'Draft',
  Submitted = 'Submitted',
}
export type ProgramSummaryDetailsType = 'WEEK' | 'MONTH' | 'CUSTOM';
export interface ProgramSummaryStatsFormat {
  type: ProgramSummaryDetailsType;
  value?: 0 | -3 | -6;
  from?: string;
  to?: string;
  product?: ProductNameEnum;
}
